import { useTranslation } from "react-i18next";
import {
  Grid as MuiGrid,
  Typography as MuiTypography,
  Link as MuiLink,
} from "@mui/material";
import { tableauReportStyles } from "app/components/reports/TableauReportStyles";
import Page from "app/shared/UI/Layout/Page";
import { handleTableauUrls } from "app/shared/utils";

const PortfolioReports = (props) => {
  const { t } = useTranslation();

  const ReportContent = () => {
    return (
      <div style={tableauReportStyles.paper}>
        <MuiGrid container spacing={2}>
          <MuiGrid>
            <MuiLink
              href={`${handleTableauUrls()}/OverviewofStudiesWaves`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <MuiTypography variant="h5" noWrap>
                {t("TableauReport.overviewStudiesReport")}
              </MuiTypography>
            </MuiLink>
          </MuiGrid>
          <MuiGrid size={12}>
            <MuiTypography sx={tableauReportStyles.descContainer}>
              {t("TableauReport.overviewOfStudiesReportDesc")}
            </MuiTypography>
          </MuiGrid>

          <MuiGrid>
            <MuiLink
              href={`${handleTableauUrls()}/StudieswithHighestReturn`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <MuiTypography variant="h5" noWrap>
                {t("TableauReport.highestReturnStudiesReport")}
              </MuiTypography>
            </MuiLink>
          </MuiGrid>
          <MuiGrid size={12}>
            <MuiTypography sx={tableauReportStyles.descContainer}>
              {t("TableauReport.highestReturnStudiesReportDesc")}
            </MuiTypography>
          </MuiGrid>

          <MuiGrid>
            <MuiLink
              href={`${handleTableauUrls()}/StudySummaryDashboard`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <MuiTypography variant="h5" noWrap>
                {t("TableauReport.studySummaryDashboardReport")}
              </MuiTypography>
            </MuiLink>
          </MuiGrid>
          <MuiGrid size={12}>
            <MuiTypography sx={tableauReportStyles.descContainer}>
              {t("TableauReport.studySummaryDashboardReportDesc")}
            </MuiTypography>
          </MuiGrid>
        </MuiGrid>
      </div>
    );
  };

  return (
    <Page
      hasDrawer={false}
      pageTitle={t("TableauReport.portfolioPageTitle")}
      hasBackButton={false}
      contentComponent={ReportContent}
      {...props}
    />
  );
};

export default PortfolioReports;
